import { render, staticRenderFns } from "./carstable.vue?vue&type=template&id=31b84dca&scoped=true"
import script from "./carstable.vue?vue&type=script&lang=js"
export * from "./carstable.vue?vue&type=script&lang=js"
import style0 from "./carstable.vue?vue&type=style&index=0&id=31b84dca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b84dca",
  null
  
)

export default component.exports